import { render, staticRenderFns } from "./pendingDoc.vue?vue&type=template&id=7e389eff&"
import script from "./pendingDoc.vue?vue&type=script&lang=js&"
export * from "./pendingDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports